import React from "react";
import ReactDOM from "react-dom/client";
import { configureApiClient } from "@hp/api-client";
import { App } from "./App";
import "./index.css";

// Points @hp/api-client at the backend for this build. Without this the
// client keeps its own `http://localhost:8000` default, which happens to be
// correct on a developer's machine and is wrong everywhere else - a
// deployed dashboard would ask the *viewer's* machine for the API.
//
// Set at build time, not runtime, because Vite substitutes import.meta.env
// into the bundle: the deploy builds with VITE_API_BASE_URL=/api, which
// puts the API on the same origin as the page (nginx proxies /api to the
// service), so the browser makes no cross-origin request at all.
configureApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000" });

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
